// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================= */
/* BADGE COMPONENT STYLES - VANTA INSPIRED     */
/* ============================================= */

.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  letter-spacing: 0.5px;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

/* Badge Sizes */
.badge-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.65rem;
}

.badge-md {
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
}

.badge-lg {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}

/* Badge Icons */
.badge-icon {
  width: 1.1em;
  height: 1.1em;
  flex-shrink: 0;
}

/* Badge Variants - Primary */
.badge-primary {
  background-color: #EFF6FF;
  color: #1E40AF;
}

.dark .badge-primary {
  background-color: rgba(14, 165, 233, 0.15);
  color: #38BDF8;
}

/* Badge Variants - Secondary */
.badge-secondary {
  background-color: #F3F4F6;
  color: #374151;
}

.dark .badge-secondary {
  background-color: rgba(107, 114, 128, 0.2);
  color: #D1D5DB;
}

/* Badge Variants - Success */
.badge-success {
  background-color: #ECFDF5;
  color: #065F46;
}

.dark .badge-success {
  background-color: rgba(34, 197, 94, 0.15);
  color: #4ADE80;
}

/* Badge Variants - Warning */
.badge-warning {
  background-color: #FFFBEB;
  color: #92400E;
}

.dark .badge-warning {
  background-color: rgba(245, 158, 11, 0.15);
  color: #FBBF24;
}

/* Badge Variants - Error */
.badge-error {
  background-color: #FFF5F7;
  color: #9F1239;
}

.dark .badge-error {
  background-color: rgba(236, 72, 153, 0.15);
  color: #F472B6;
}

/* Badge Variants - Info */
.badge-info {
  background-color: #F0F9FF;
  color: #0C4A6E;
}

.dark .badge-info {
  background-color: rgba(14, 165, 233, 0.15);
  color: #38BDF8;
}

/* Badge Outline Variants */
.badge-outline {
  background-color: transparent;
  border: 1px solid currentColor;
}

.badge-outline.badge-primary {
  color: #2563EB;
  border-color: #2563EB;
}

.dark .badge-outline.badge-primary {
  color: #38BDF8;
  border-color: #38BDF8;
}

.badge-outline.badge-success {
  color: #22C55E;
  border-color: #22C55E;
}

.dark .badge-outline.badge-success {
  color: #4ADE80;
  border-color: #4ADE80;
}

.badge-outline.badge-warning {
  color: #F59E0B;
  border-color: #F59E0B;
}

.dark .badge-outline.badge-warning {
  color: #FBBF24;
  border-color: #FBBF24;
}

.badge-outline.badge-error {
  color: #EC4899;
  border-color: #EC4899;
}

.dark .badge-outline.badge-error {
  color: #F472B6;
  border-color: #F472B6;
}

/* Badge Dot Variant */
.badge-dot::before {
  content: '';
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: currentColor;
  display: inline-block;
  margin-right: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/Badge.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,gDAAgD;AAChD,kDAAkD;;AAElD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;AACvB","sourcesContent":["/* ============================================= */\n/* BADGE COMPONENT STYLES - VANTA INSPIRED     */\n/* ============================================= */\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.375rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n  letter-spacing: 0.5px;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n}\n\n/* Badge Sizes */\n.badge-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.65rem;\n}\n\n.badge-md {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.75rem;\n}\n\n.badge-lg {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n}\n\n/* Badge Icons */\n.badge-icon {\n  width: 1.1em;\n  height: 1.1em;\n  flex-shrink: 0;\n}\n\n/* Badge Variants - Primary */\n.badge-primary {\n  background-color: #EFF6FF;\n  color: #1E40AF;\n}\n\n.dark .badge-primary {\n  background-color: rgba(14, 165, 233, 0.15);\n  color: #38BDF8;\n}\n\n/* Badge Variants - Secondary */\n.badge-secondary {\n  background-color: #F3F4F6;\n  color: #374151;\n}\n\n.dark .badge-secondary {\n  background-color: rgba(107, 114, 128, 0.2);\n  color: #D1D5DB;\n}\n\n/* Badge Variants - Success */\n.badge-success {\n  background-color: #ECFDF5;\n  color: #065F46;\n}\n\n.dark .badge-success {\n  background-color: rgba(34, 197, 94, 0.15);\n  color: #4ADE80;\n}\n\n/* Badge Variants - Warning */\n.badge-warning {\n  background-color: #FFFBEB;\n  color: #92400E;\n}\n\n.dark .badge-warning {\n  background-color: rgba(245, 158, 11, 0.15);\n  color: #FBBF24;\n}\n\n/* Badge Variants - Error */\n.badge-error {\n  background-color: #FFF5F7;\n  color: #9F1239;\n}\n\n.dark .badge-error {\n  background-color: rgba(236, 72, 153, 0.15);\n  color: #F472B6;\n}\n\n/* Badge Variants - Info */\n.badge-info {\n  background-color: #F0F9FF;\n  color: #0C4A6E;\n}\n\n.dark .badge-info {\n  background-color: rgba(14, 165, 233, 0.15);\n  color: #38BDF8;\n}\n\n/* Badge Outline Variants */\n.badge-outline {\n  background-color: transparent;\n  border: 1px solid currentColor;\n}\n\n.badge-outline.badge-primary {\n  color: #2563EB;\n  border-color: #2563EB;\n}\n\n.dark .badge-outline.badge-primary {\n  color: #38BDF8;\n  border-color: #38BDF8;\n}\n\n.badge-outline.badge-success {\n  color: #22C55E;\n  border-color: #22C55E;\n}\n\n.dark .badge-outline.badge-success {\n  color: #4ADE80;\n  border-color: #4ADE80;\n}\n\n.badge-outline.badge-warning {\n  color: #F59E0B;\n  border-color: #F59E0B;\n}\n\n.dark .badge-outline.badge-warning {\n  color: #FBBF24;\n  border-color: #FBBF24;\n}\n\n.badge-outline.badge-error {\n  color: #EC4899;\n  border-color: #EC4899;\n}\n\n.dark .badge-outline.badge-error {\n  color: #F472B6;\n  border-color: #F472B6;\n}\n\n/* Badge Dot Variant */\n.badge-dot::before {\n  content: '';\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  background-color: currentColor;\n  display: inline-block;\n  margin-right: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
